// @flow

import type { SpecialContactTypesState } from "./types";

export const initialState: SpecialContactTypesState = {
  requestsInProgress: 0,
  list: {
    content: [],
    pagination: {
      pageNumber: 0,
      pageSize: 0,
      offset: 0,
      sort: { orders: [] },
    },
    totalElements: 0,
  },
};

export default initialState;
